<template>
  <div
    id="question-information"
    class="mt-2 card-wrp"
    :class="!formData.isEdit ? 'bypass' : ''"
  >
    <b-card no-body class="container-card mb-1">
      <b-row>
        <b-col
          cols="12"
          class="card-wrp mt-2 d-flex align-item-start flex-column"
          @click="toggleActive(activeHover.QUIZ_NAME)"
        >
          <div :class="activeQuizName ? 'bg' : 'bg-hover'">
            <div :class="activeQuizName ? 'card-inner' : 'card-inner-hover'">
              <div
                class="editor font-large-1"
                v-if="!activeQuizName && nameNoHtml"
                v-safe-html="formData.surveyName"
              ></div>

              <div
                v-if="!activeQuizName && !nameNoHtml"
                class="text-no-data-wrp"
              >
                <div
                  data-placeholder="Name"
                  class="text-no-data font-large-1 w-80"
                ></div>
              </div>
              <div id="toolbar-editor" v-if="activeQuizName">
                <quill-editor
                  id="quiz-name"
                  toolbar="#my-toolbar"
                  ref="quizNameQuill"
                  class="custom-quill-editor flex-stretch h-100 font-medium-5"
                  :options="customQuillOption"
                  v-model="formData.surveyName"
                  required
                  @ready="onFocusInput('quizNameQuill')"
                >
                </quill-editor>
              </div>
            </div>
          </div>
          <div id="toolbar-editor" class="toolbar-wrp">
            <div id="my-toolbar" v-if="activeQuizName">
              <custom-toolbar />
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="card-wrp mb-1"
          @click="toggleActive(activeHover.QUIZ_DESC)"
        >
          <div :class="activeQuizDesc ? 'bg' : 'bg-hover'">
            <div :class="activeQuizDesc ? 'card-inner' : 'card-inner-hover'">
              <div
                class="editor font-medium-4"
                v-if="!activeQuizDesc && descNoHtml"
                v-safe-html="formData.surveyDesc"
              ></div>
              <div
                class="text-no-data-wrp"
                v-if="!activeQuizDesc && !descNoHtml"
              >
                <div
                  data-placeholder="Description"
                  class="text-no-data font-medium-4 w-80"
                ></div>
              </div>
              <div id="toolbar-editor" v-if="activeQuizDesc">
                <quill-editor
                  toolbar="#my-toolbar"
                  ref="quizDescQuill"
                  class="custom-quill-editor flex-stretch h-100 text-desc"
                  :options="customQuillOption"
                  v-model="formData.surveyDesc"
                  @ready="onFocusInput('quizDescQuill')"
                >
                </quill-editor>
              </div>
            </div>
          </div>
          <div id="toolbar-editor" v-if="activeQuizDesc" class="toolbar-wrp">
            <div id="my-toolbar">
              <custom-toolbar :isListbullet="true" :isListOrdered="true" />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body class="py-2 px-3 container-card mb-1" @click="toggleActive">
      <b-row>
        <b-col cols="12" md="6">
          <div class="font-medium-4">
            <span class="text-black mr-2 required">Cover Banner</span>
            <span class="desc-title">(Format JPG, JPEG, PNG Max 2 Mb)</span>
          </div>
          <image-upload
            :removable="true"
            :image-url="formData.bannerImage.url"
            @onUpload="onUploadBanner"
          />
        </b-col>
        <b-col cols="12" md="6">
          <div class="font-medium-4">
            <span class="text-black mr-2 required">Display</span>
            <span class="desc-title">(Format JPG, JPEG, PNG Max 2 Mb)</span>
          </div>
          <image-upload
            :removable="true"
            :image-url="formData.displayImage.url"
            @onUpload="onUploadDisplay"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body class="py-2 px-3 container-card mb-1" @click="toggleActive">
      <b-row>
        <b-col cols="12">
          <div class="font-medium-5 text-black">Setting Duedate</div>
          <div class="mt-1">
            <span class="font-medium-4 text-black">{{ "Status" }} </span>
            <b-form-checkbox
              v-model="formData.status"
              field-value="true"
              class="custom-control-success custom-toggle mt-1"
              name="check-button"
              switch
              :disabled="!formData.isEdit"
            >
              <span class="switch-icon-left toggle-text">{{ "Active" }}</span>
              <span class="switch-icon-right toggle-text">{{
                "Inactive"
              }}</span>
            </b-form-checkbox>
          </div>
          <div>
            <b-row>
              <b-col cols="4">
                <label
                  for="valid-from-date"
                  class="title-name font-medium-4 text-black required mt-2"
                >
                  Valid From</label
                >
                <div class="d-flex">
                  <div class="p-0 p-relative mr-2">
                    <calendar-picker-icon
                      class="icon-calendar bypass"
                      :class="
                        formData.validFrom.date ? 'date-selected-icon' : null
                      "
                    />
                    <flat-pickr
                      :id="'valid-from-date'"
                      v-model="formData.validFrom.date"
                      class="form-control bg-date"
                      :class="formData.validFrom.date ? 'date-selected' : null"
                      :config="flatpickrDateConfig"
                      placeholder="Select Date"
                      autocomplete="off"
                      required
                      @on-open="
                        flatpickrDateConfig.maxDate = formData.validThrough.date
                      "
                    />
                  </div>
                  <div class="p-0 p-relative">
                    <clock-picker-icon
                      class="icon-calendar date-picker-icon bypass"
                      :class="
                        formData.validFrom.time ? 'date-selected-icon' : null
                      "
                    />
                    <flat-pickr
                      id="valid-from-time"
                      v-model="formData.validFrom.time"
                      class="form-control bg-date"
                      :class="formData.validFrom.time ? 'date-selected' : null"
                      :config="flatpickrTimeConfig"
                      :placeholder="'Select Time'"
                      required
                      autocomplete="off"
                      @on-change="
                        () => {
                          if (
                            formData.validFrom.date ==
                              formData.validThrough.date &&
                            formData.validFrom.time > formData.validThrough.time
                          ) {
                            formData.validThrough.time = null;
                          }
                        }
                      "
                    />
                  </div>
                </div>
              </b-col>
              <b-col cols="4">
                <label
                  for="valid-through-date"
                  class="title-name font-medium-4 text-black required mt-2"
                >
                  Valid Through
                </label>
                <div class="d-flex">
                  <div class="p-0 p-relative mr-2">
                    <calendar-picker-icon
                      class="icon-calendar bypass"
                      :class="
                        formData.validThrough.date ? 'date-selected-icon' : null
                      "
                    />
                    <flat-pickr
                      :id="'valid-through-date'"
                      v-model="formData.validThrough.date"
                      class="form-control bg-date"
                      :class="
                        formData.validThrough.date ? 'date-selected' : null
                      "
                      :config="flatpickrDateConfig"
                      placeholder="Select Date"
                      autocomplete="off"
                      required
                      @on-open="
                        flatpickrDateConfig.minDate = formData.validFrom.date
                      "
                    />
                  </div>
                  <div class="p-0 p-relative">
                    <clock-picker-icon
                      class="icon-calendar date-picker-icon bypass"
                      :class="
                        formData.validThrough.time ? 'date-selected-icon' : null
                      "
                    />
                    <flat-pickr
                      id="valid-from-time"
                      v-model="formData.validThrough.time"
                      class="form-control bg-date"
                      :class="
                        formData.validThrough.time ? 'date-selected' : null
                      "
                      :config="flatpickrTimeConfig"
                      :placeholder="'Select Time'"
                      autocomplete="off"
                      required
                      @on-open="
                        () => {
                          if (
                            formData.validFrom.date ==
                            formData.validThrough.date
                          ) {
                            flatpickrTimeConfig.minTime =
                              formData.validFrom.time;
                          }
                        }
                      "
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-emoji/dist/quill-emoji.css";
import Quill from "quill";
import QuillEmoji from "quill-emoji";
import CustomToolbar from "../CustomToolbarEditor.vue";
import ImageUpload from "@/views/pages/survey-quiz/quiz-info/Components/ImageUpload.vue";
import useInformation from "../../hooks/useInformation";

export default {
  components: {
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    CustomToolbar,
    ImageUpload,
  },
  props: {
    formData: { type: Object, default: {} },
  },
  setup(props) {
    const {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      toggleActive,
      activeHover,
      customQuillOption,
      onFocusInput,
      activeQuizName,
      activeQuizDesc,
      onUploadBanner,
      onUploadDisplay,
      nameNoHtml,
      descNoHtml,
    } = useInformation(props);

    return {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      toggleActive,
      activeHover,
      customQuillOption,
      onFocusInput,
      activeQuizName,
      activeQuizDesc,
      onUploadBanner,
      onUploadDisplay,
      nameNoHtml,
      descNoHtml,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/pages/quiz/toolbar-editor.css";
@import "~@/assets/css/pages/quiz/information.css";
</style>